export default 'MpHpInitialFeed';
